import script from "./mg-homepage.vue?vue&type=script&setup=true&lang=js"
export * from "./mg-homepage.vue?vue&type=script&setup=true&lang=js"

import "./mg-homepage.vue?vue&type=style&index=0&id=2ea1f49c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea1f49c"]])

export default __exports__